var render = function render(){var _vm=this,_c=_vm._self._c;return _c('img',{staticClass:"divider-img",attrs:{"src":require("@/assets/member/heng.png")}})
}
var staticRenderFns = []

export { render, staticRenderFns }